import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import classNames from 'classnames';
import {ChangeEvent, FC} from 'react';
import style from './style.module.scss';

interface IProps {
    count?: number;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onDecrement: () => void;
    onIncrement: () => void;
    disabledIncrement?: boolean;
}

export const ProductCounter: FC<IProps> = ({count, onChange, onDecrement, onIncrement, disabledIncrement}) => {
    return (
        <div className={style.main}>
            <div className={style.titleContainer}>
                <Typography className={style.title} variant={'button-14-m-cl'}>
                    В корзине
                </Typography>
            </div>
            <div className={style.content}>
                <button className={style.button} onClick={onDecrement} type={'button'}>
                    <Icon className={style.icon} icon={'minus'} />
                </button>
                <input className={style.input} onChange={onChange} type={'text'} value={count ?? 1} />
                <button
                    className={classNames(style.button, style.buttonPlus)}
                    onClick={onIncrement}
                    type={'button'}
                    disabled={disabledIncrement}
                >
                    <Icon className={style.icon} icon={'plus'} />
                </button>
            </div>
        </div>
    );
};
